import { render, staticRenderFns } from "./AddCompaniesGroupComponent.vue?vue&type=template&id=407df8bb&scoped=true&"
import script from "./AddCompaniesGroupComponent.vue?vue&type=script&lang=js&"
export * from "./AddCompaniesGroupComponent.vue?vue&type=script&lang=js&"
import style0 from "./AddCompaniesGroupComponent.vue?vue&type=style&index=0&id=407df8bb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "407df8bb",
  null
  
)

export default component.exports